import React, { useState } from "react";
import Link from "next/link";
import Crumbs from "@/components/navigation/Crumbs";
import FeaturedTitleCustom from "./FeaturedTitleCustom";
import RelatedContent from "@/components/movies/RelatedContent";
import Button from "@/components/actions/Button";
import { ArrowRightIcon } from "@heroicons/react/outline";
import Testimonials from "./Testimonials";
import Editions from "./Editions";
import * as Text from "@/components/text";

import { motion } from "framer-motion";

export default function GiraDocumental({ dataGira }) {
  const [color, setColor] = useState(0);
  return (
    <div className="flex flex-col items-center justify-center">
      <motion.div className="amb-container">
        <div className="flex flex-row gap-2 py-4">
          <Crumbs breadcrumbs={[{ href: "/", text: "Programas" }]} />
          <span className=" text-neutral-600">Gira de Documentales</span>
        </div>
        <div className="flex flex-col items-center justify-center mb-8 text-center mt-7 md:mt-10 md:px-28 lg:mt-14 lg:px-32">
          <div className="w-full font-bold text-center text-gira">
            <Text.Title className="text-[22px] md:text-2xl md:font-semibold lg:text-2xl">
              {dataGira?.headertitle?.h1}
            </Text.Title>
            
          </div>
          <div className="w-full px-4 py-2 text-center text-4xl font-bold leading-9 md:mb-4 md:mt-4 md:px-24 md:text-[30px] lg:px-32 lg:text-4xl">
            <h2>{dataGira?.headertitle?.h2}</h2>
          </div>
          <div className="text-center font-light tracking-[-0.8px] text-neutral-800 md:w-[690px] md:px-28 md:text-2xl md:leading-[28px] lg:px-0 lg:text-[40px] lg:leading-[42px]">
            <span>{dataGira?.headertitle?.description}</span>
          </div>
          { dataGira?.headertitle?.large_description ? 
            (
              <div className={`w-full max-w-[950px]  text-center text-sm font-light leading-7 lg:mt-4 lg:text-[18px] lg:leading-[22px] bg-[#fdf2f2] p-4 rounded-md`}>
                {dataGira?.headertitle?.large_description}
              </div>
            ): null
          }
          <div className="sm:h-[600px] sm:w-[360px] md:h-[496px] md:w-[744px] lg:h-[756px] lg:w-[1440px] sm:mt-8 lg:mt-10">
            <video
              autoPlay
              muted
              loop
              id="myVideo"
              poster="/next_assets/img/brand-assets/hero_bg.jpg"
              className="top-0 object-cover w-full h-full"
            >
              <source
                src="/next_assets/video/AMB_CINESPOT_WEB.webm"
                type="video/webm"
              />
            </video>
          </div>
        </div>
        <div className="flex w-full font-light tracking-[-0.8px] sm:justify-center sm:px-4 sm:pb-4 sm:text-center sm:text-[24px] sm:leading-[28px] md:pb-8 md:text-[32px] lg:justify-start lg:px-0 lg:text-left lg:text-[40px] lg:leading-[42px]">
          <span>Histórico de películas programadas</span>
        </div>
        <div className="grid justify-center w-full gap-4">
          <div className="lg:grid  w-full gap-4 sm:max-w-[328px] md:max-w-[680px] lg:max-w-[1208px] lg:grid-cols-3">
            <div className="relative mb-5 md:mb-0 col-span-2 w-full space-y-11 md:max-h-full md:max-w-[680px] lg:mx-auto lg:max-w-[795px]">
              {dataGira?.peliculas?.data[0] && (
                <FeaturedTitleCustom
                  active={true}
                  setColor={setColor}
                  film_name={dataGira.peliculas.data[0].attributes.film_name}
                  slug={dataGira.peliculas.data[0].attributes.filmSlug}
                  original_title={
                    dataGira.peliculas.data[0].attributes.film_original_title
                  }
                  directors={dataGira.peliculas.data[0].attributes.Directores}
                  film_length={
                    dataGira.peliculas.data[0].attributes.film_length
                  }
                  countries={dataGira.peliculas.data[0].attributes.countries}
                  film_cover={
                    dataGira.peliculas.data[0].attributes.film_cover_image
                  }
                  initiatives={
                    dataGira.peliculas.data[0].attributes.iniciativas
                  }
                  film_year={dataGira.peliculas.data[0].attributes.film_year}
                />
              )}
            </div>
            <div className="gap-4 sm:grid w-full md:flex md:w-[680px] lg:col-span-1 lg:grid lg:w-full">
              <div className="relative w-full space-y-11 sm:h-[172px] md:h-[200px] md:w-[332px] lg:h-[260px] lg:w-[397px] xl:mx-auto">
                {dataGira?.peliculas?.data[1] && (
                  <FeaturedTitleCustom
                    active={true}
                    setColor={setColor}
                    film_name={dataGira.peliculas.data[1].attributes.film_name}
                    slug={dataGira.peliculas.data[1].attributes.filmSlug}
                    original_title={
                      dataGira.peliculas.data[1].attributes.film_original_title
                    }
                    directors={dataGira.peliculas.data[1].attributes.Directores}
                    film_length={
                      dataGira.peliculas.data[1].attributes.film_length
                    }
                    countries={dataGira.peliculas.data[1].attributes.countries}
                    film_cover={
                      dataGira.peliculas.data[1].attributes.film_cover_image
                    }
                    initiatives={
                      dataGira.peliculas.data[1].attributes.iniciativas
                    }
                    film_year={dataGira.peliculas.data[1].attributes.film_year}
                  />
                )}
              </div>
              <div className="relative w-full space-y-11 md:h-[200px] md:w-[332px] lg:h-[260px] lg:w-[397px] xl:mx-auto">
                {dataGira?.peliculas?.data[2] && (
                  <FeaturedTitleCustom
                    active={true}
                    setColor={setColor}
                    film_name={dataGira.peliculas.data[2].attributes.film_name}
                    slug={dataGira.peliculas.data[2].attributes.filmSlug}
                    original_title={
                      dataGira.peliculas.data[2].attributes.film_original_title
                    }
                    directors={dataGira.peliculas.data[2].attributes.Directores}
                    film_length={
                      dataGira.peliculas.data[2].attributes.film_length
                    }
                    countries={dataGira.peliculas.data[2].attributes.countries}
                    film_cover={
                      dataGira.peliculas.data[2].attributes.film_cover_image
                    }
                    initiatives={
                      dataGira.peliculas.data[2].attributes.iniciativas
                    }
                    film_year={dataGira.peliculas.data[2].attributes.film_year}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="lg:grid h-full w-full gap-4 md:w-[680px] md:grid-cols-2 lg:w-[1213px] lg:grid-cols-4">
            <div className="relative w-full space-y-11 xl:mx-auto xl:max-w-[795px]">
              {dataGira?.peliculas?.data[3] && (
                <FeaturedTitleCustom
                  active={true}
                  setColor={setColor}
                  film_name={dataGira.peliculas.data[3].attributes.film_name}
                  slug={dataGira.peliculas.data[3].attributes.filmSlug}
                  original_title={
                    dataGira.peliculas.data[3].attributes.film_original_title
                  }
                  directors={dataGira.peliculas.data[3].attributes.Directores}
                  film_length={
                    dataGira.peliculas.data[3].attributes.film_length
                  }
                  countries={dataGira.peliculas.data[3].attributes.countries}
                  film_cover={
                    dataGira.peliculas.data[3].attributes.film_cover_image
                  }
                  initiatives={
                    dataGira.peliculas.data[3].attributes.iniciativas
                  }
                  film_year={dataGira.peliculas.data[3].attributes.film_year}
                />
              )}
            </div>
            <div className="relative w-full space-y-11 xl:mx-auto xl:max-w-[795px]">
              {dataGira?.peliculas?.data[4] && (
                <FeaturedTitleCustom
                  active={true}
                  setColor={setColor}
                  film_name={dataGira.peliculas.data[4].attributes.film_name}
                  slug={dataGira.peliculas.data[4].attributes.filmSlug}
                  original_title={
                    dataGira.peliculas.data[4].attributes.film_original_title
                  }
                  directors={dataGira.peliculas.data[4].attributes.Directores}
                  film_length={
                    dataGira.peliculas.data[4].attributes.film_length
                  }
                  countries={dataGira.peliculas.data[4].attributes.countries}
                  film_cover={
                    dataGira.peliculas.data[4].attributes.film_cover_image
                  }
                  initiatives={
                    dataGira.peliculas.data[4].attributes.iniciativas
                  }
                  film_year={dataGira.peliculas.data[4].attributes.film_year}
                />
              )}
            </div>
            <div className="relative w-full space-y-11 xl:mx-auto xl:max-w-[795px]">
              {dataGira?.peliculas?.data[5] && (
                <FeaturedTitleCustom
                  active={true}
                  setColor={setColor}
                  film_name={dataGira.peliculas.data[5].attributes.film_name}
                  slug={dataGira.peliculas.data[5].attributes.filmSlug}
                  original_title={
                    dataGira.peliculas.data[5].attributes.film_original_title
                  }
                  directors={dataGira.peliculas.data[5].attributes.Directores}
                  film_length={
                    dataGira.peliculas.data[5].attributes.film_length
                  }
                  countries={dataGira.peliculas.data[5].attributes.countries}
                  film_cover={
                    dataGira.peliculas.data[5].attributes.film_cover_image
                  }
                  initiatives={
                    dataGira.peliculas.data[5].attributes.iniciativas
                  }
                  film_year={dataGira.peliculas.data[5].attributes.film_year}
                />
              )}
            </div>
            <div className="relative w-full space-y-11 xl:mx-auto xl:max-w-[795px]">
              {dataGira?.peliculas?.data[6] && (
                <FeaturedTitleCustom
                  active={true}
                  setColor={setColor}
                  film_name={dataGira.peliculas.data[6].attributes.film_name}
                  slug={dataGira.peliculas.data[6].attributes.filmSlug}
                  original_title={
                    dataGira.peliculas.data[6].attributes.film_original_title
                  }
                  directors={dataGira.peliculas.data[6].attributes.Directores}
                  film_length={
                    dataGira.peliculas.data[6].attributes.film_length
                  }
                  countries={dataGira.peliculas.data[6].attributes.countries}
                  film_cover={
                    dataGira.peliculas.data[6].attributes.film_cover_image
                  }
                  initiatives={
                    dataGira.peliculas.data[6].attributes.iniciativas
                  }
                  film_year={dataGira.peliculas.data[6].attributes.film_year}
                />
              )}
            </div>
          </div>
          <div className="flex justify-center w-full">
            <Link href="/catalogo/" passHref>
              <Button
                type="submit"
                color="secondary-light"
                size="lg"
                className="sm:mb-8 sm:w-[328px] md:w-fit lg:mb-20 lg:mt-8"
                trailingIcon={<ArrowRightIcon />}
                label="Ver todo el catálogo"
              ></Button>
            </Link>
          </div>
        </div>
      </motion.div>
      <Testimonials
        title={"Un encuentro"}
        subtitle={" emocionante y significativo"}
        quotes={dataGira?.quotes}
      />
      <motion.div className="amb-container">
        <Editions editions={dataGira?.edicion} />

        <div className="my-5">
          <RelatedContent
            movieId={dataGira?.peliculas?.data[2]?.id}
            showMovie={false}
            showEvents={false}
          />
        </div>
      </motion.div>
    </div>
  );
}
